import "../styles/login.css";
import React, { useEffect, useState } from "react";
import logincrsimg from "../assets/images/logincrsimg.png";
import { loginUser } from "../apis/auth";
import api from "../apis/axios";
import axios from "axios";
import { toast } from "react-toastify";
import ApiLoader from "../components/ApiLoader";
import FingerprintScannerLoader from "../components/FingerprintScannerLoader";
import fingerPrintServices, {
  FingerPrintResult,
} from "../services/fingerPrintService";
import { Dispatch } from "@reduxjs/toolkit";
import { logIn } from "../redux-store/slices/authSlice";
import { useDispatch, useSelector } from "react-redux";
import API_BASE_URL from "../utilities/ApiConfig";
import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import UpdateThumb from "../Modal/UpdateThumb";

const Login = () => {
  const initialLoginParams = {
    email: "",
    password: "",
  };

  const navigate = useNavigate();

  const initialUserDetails = {
    createdOn: "",
    dcode: "",
    email: "",
    id: 0,
    lastLogin: "",
    mobileNo: "",
    password: "",
    srocode: "",
    status: "",
    thumb: "",
    userDesig: "",
    userRole: "",
    username: "",
  };

  const [loginParams, setLoginParams] = useState(initialLoginParams);
  const [loginResponse, setLoginResponse] = useState();
  const [userLoginDetails, setUserLoginDetails] = useState();
  const [loading, setLoading] = useState(false);
  const [fingerprintScannerLoading, setFingerprintScannerLoading] =
    useState(false);
  const [error, setError] = useState(null);
  const [isThumbPopupOpen, setIsThumbPopupOpen] = useState(false);
  const [token, setToken] = useState(null);
  const [fingerprintData, setFingerprintData] = useState("");
  const [databaseFingerprint, setDatabaseFingerprint] = useState("");
  const [intializeFingerprintCapture, setIntializeFingerprintCapture] =
    useState(0);

  const {
    callSGIFPGetData,
    successFunc1,
    errorFunc,
    matchFingerPrint,
    succMatch,
    failureFunc,
  } = fingerPrintServices();

  // comment by khalid to bypass fingerprint starts

  // const handleSubmit = async (event) => {
  //   event.preventDefault();
  //   setLoginResponse(loginResponse);
  //   setLoading(true);

  //   try {
  //     const response = await axios.post(
  //       `${API_BASE_URL}/Auth/login_user`,
  //       loginParams
  //     );

  //     if (response.data.statusCode === 200) {
  //       //debugger
  //       // toast.success(response.data.status);
  //       setUserLoginDetails(response.data.userDetails);
  //       console.log("User Login Response", response.data);
  //       setDatabaseFingerprint(response.data.userDetails.thumb);
  //       setIntializeFingerprintCapture(intializeFingerprintCapture + 1);
  //     } else {
  //       toast.error(response.data.status);
  //     }
  //   } catch (error) {
  //     toast.error("An error occurred. Please try again.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // comment by khalid to bypass fingerprint ends

  // const handleSubmit = async (event) => {
  //   event.preventDefault();
  //   setLoginResponse(loginResponse);
  //   setLoading(true);

  //   try {
  //     const response = await axios.post(
  //       `${API_BASE_URL}/Auth/login_user`,
  //       loginParams
  //     );

  //     if (response.data.statusCode === 200) {
  //       debugger;
  //       dispatch(logIn(response.data.userDetails));
  //       console.log("User Login Response", response.data);
  //       // toast.success(response.data.status);
  //       setUserLoginDetails(response.data.userDetails);
  //       console.log("User Login Response", response.data);
  //       if (response.data.userDetails?.userRole === "SuperAdmin") {
  //         navigate("/DashboardAIG");
  //       } else {
  //         debugger;

  //         setDatabaseFingerprint(response.data.userDetails.thumb);
  //         setIntializeFingerprintCapture(intializeFingerprintCapture + 1);
  //       }
  //     } else {
  //       toast.error(response.data.status);
  //     }
  //   } catch (error) {
  //     toast.error("An error occurred. Please try again.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  //changes by khalid to bypass fingerprint starts
  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoginResponse(loginResponse);
    setLoading(true);

    try {
      const response = await axios.post(
        `${API_BASE_URL}/Auth/login_user`,
        loginParams
      );

      if (response.data.statusCode === 200) {
        dispatch(logIn(response.data.userDetails));
        console.log("User Login Response", response.data);

        if (response.data.userDetails?.userRole === "SuperAdmin") {
          navigate("/DashboardAIG");
        } else if (response.data.userDetails?.userRole === "ItCell") {
          navigate("/PowerRegularizationItCell");
        } else if (response.data.userDetails?.userRole === "NIC Director") {
          navigate("/DashboardRegDetails");
        } else {
          navigate("/Dashboard");
        }
      } else {
        toast.error(response.data.status);
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // changes by khalid to bypass fingerprint ends

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLoginParams({ ...loginParams, [name]: value });
  };

  const dispatch = useDispatch();
  const { isLoggedIn, userDetails } = useSelector((state) => state.auth);
  console.log(userDetails);

  const captureFingerprint = () => {
    setFingerprintScannerLoading(true);
    callSGIFPGetData((result) => {
      successFunc1(result);
      setFingerprintData(result.ISOTemplateBase64);
      // setImageSrc2("data:image/bmp;base64," + result.BMPBase64);
    }, errorFunc);
  };

  const matchFingerprints = () => {
    setFingerprintScannerLoading(true);
    matchFingerPrint(
      databaseFingerprint,
      fingerprintData,
      (result) => {
        const matchResult = succMatch(result);

        // setMatchResult(matchResult);
        // console.log(matchResult);

        if (matchResult.matched) {
          toast.success("fingerpirnt matched successfully");
          if (userLoginDetails) {
            dispatch(logIn(userLoginDetails));
            navigate("/Dashboard");
          }
        } else {
          toast.error("fingerpirnt does not matched please try again");
        }
        return matchResult;
      },
      (error) => {
        const matchResult = failureFunc(error);
        toast.error("please scan your fingerpirnt again");
        // setMatchResult(matchResult);
        return matchResult;
      }
    ).catch((error) => {
      console.error("Match error:", error);
      toast.error("please scan your fingerpirnt again");
    });
    setFingerprintScannerLoading(false);
  };

  useEffect(() => {
    if (databaseFingerprint) {
      captureFingerprint();
    }
  }, [intializeFingerprintCapture]);

  useEffect(() => {
    if (fingerprintData) {
      matchFingerprints();
    }
  }, [fingerprintData]);

  return (
    <>
      {loading && <ApiLoader />}
      {fingerprintScannerLoading && <FingerprintScannerLoader />}

      {/* Main Content */}
      <div className="flex flex-col bg-[#ffffff] overflow-hidden min-h-screen relative">
        {/* Header positioned at the top-left */}
        <div className="absolute top-0 left-0 p-4">
          <Header />
        </div>

        {/* Content Area */}
        <div className="flex-1 flex flex-col md:flex-row">
          {/* Left Section */}
          <div className="flex-1 flex flex-col items-center justify-center p-4 md:p-6">
            <div className="w-full max-w-md bg-white items-center justify-center rounded-lg dark:bg-gray-800 p-6 space-y-4 md:space-y-6 sm:p-8 mt-12 md:mt-24">
              <div className="centered-container text-center">
                <h1 className="text-2xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
                  <strong>Welcome To CRS Login</strong>
                </h1>
                <h1 className="text-lg mt-2">Enter Your Login ID & Password</h1>
              </div>

              <form className="space-y-4 md:space-y-6" action="#">
                {/* Email Input */}
                <div>
                  <label
                    htmlFor="email"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    id="email"
                    value={loginParams.email}
                    onChange={handleInputChange}
                    className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder="name@company.com"
                    required
                  />
                </div>

                {/* Password Input */}
                <div>
                  <label
                    htmlFor="password"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Password
                  </label>
                  <input
                    type="password"
                    name="password"
                    id="password"
                    value={loginParams.password}
                    onChange={handleInputChange}
                    className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder="••••••••"
                    required
                  />
                </div>

                {/* Sign In & Register Thumb Buttons */}
                <div className="mt-4 flex gap-4">
                  <button
                    type="submit"
                    onClick={handleSubmit}
                    className="w-full py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-black hover:bg-slate-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  >
                    Sign in
                  </button>

                  <button
                    type="button"
                    onClick={() => setIsThumbPopupOpen(true)}
                    className="w-full py-2 px-4 border border-gray-400 text-sm font-medium rounded-md text-black bg-gray-200 hover:bg-gray-300 focus:outline-none"
                  >
                    Register Thumb
                  </button>
                </div>
              </form>
            </div>

            {/* Show UpdateThumb Popup When isThumbPopupOpen is true */}
            {isThumbPopupOpen && (
              <UpdateThumb handleClose={() => setIsThumbPopupOpen(false)} />
            )}
          </div>

          {/* Right Section */}
          <div className="flex-1 hidden md:flex justify-center items-center curved-background">
            <img
              src={logincrsimg}
              alt="Images"
              className="max-w-full h-auto object-cover"
            />
          </div>
        </div>
        {/* Footer */}
        <Footer />
      </div>
    </>
  );
};

export default Login;

// import "../styles/login.css";
// import React, { useEffect, useState } from "react";
// import logincrsimg from "../assets/images/logincrsimg.png";
// import { loginUser } from "../apis/auth";
// import api from "../apis/axios";
// import axios from "axios";
// import { toast } from "react-toastify";
// import ApiLoader from "../components/ApiLoader";
// import FingerprintScannerLoader from "../components/FingerprintScannerLoader";
// import fingerPrintServices, {
//   FingerPrintResult,
// } from "../services/fingerPrintService";
// import { Dispatch } from "@reduxjs/toolkit";
// import { logIn } from "../redux-store/slices/authSlice";
// import { useDispatch, useSelector } from "react-redux";
// import API_BASE_URL from "../utilities/ApiConfig";
// import { useNavigate } from "react-router-dom";
// import Footer from "../components/Footer";
// import Header from "../components/Header";

// const Login = () => {
//   const initialLoginParams = {
//     email: "",
//     password: "",
//   };

//   const navigate = useNavigate();

//   const initialUserDetails = {
//     createdOn: "",
//     dcode: "",
//     email: "",
//     id: 0,
//     lastLogin: "",
//     mobileNo: "",
//     password: "",
//     srocode: "",
//     status: "",
//     thumb: "",
//     userDesig: "",
//     userRole: "",
//     username: "",
//   };

//   const [loginParams, setLoginParams] = useState(initialLoginParams);
//   const [loginResponse, setLoginResponse] = useState();
//   const [userLoginDetails, setUserLoginDetails] = useState();
//   const [loading, setLoading] = useState(false);
//   const [fingerprintScannerLoading, setFingerprintScannerLoading] =
//     useState(false);
//   const [error, setError] = useState(null);
//   const [token, setToken] = useState(null);
//   const [fingerprintData, setFingerprintData] = useState("");
//   const [databaseFingerprint, setDatabaseFingerprint] = useState("");
//   const [intializeFingerprintCapture, setIntializeFingerprintCapture] =
//     useState(0);

//   const {
//     callSGIFPGetData,
//     successFunc1,
//     errorFunc,
//     matchFingerPrint,
//     succMatch,
//     failureFunc,
//   } = fingerPrintServices();

//   // comment by khalid to bypass fingerprint starts

//   const handleSubmit = async (event) => {
//     event.preventDefault();
//     setLoginResponse(loginResponse);
//     setLoading(true);

//     try {
//       const response = await axios.post(
//         `${API_BASE_URL}/Auth/login_user`,
//         loginParams
//       );

//       if (response.data.statusCode === 200) {
//         //debugger
//         // toast.success(response.data.status);
//         setUserLoginDetails(response.data.userDetails);
//         console.log("User Login Response", response.data);
//         setDatabaseFingerprint(response.data.userDetails.thumb);
//         setIntializeFingerprintCapture(intializeFingerprintCapture + 1);
//       } else {
//         toast.error(response.data.status);
//       }
//     } catch (error) {
//       toast.error("An error occurred. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // comment by khalid to bypass fingerprint ends

//   // changes by khalid to bypass fingerprint starts
//   // const handleSubmit = async (event) => {
//   //   event.preventDefault();
//   //   setLoginResponse(loginResponse);
//   //   setLoading(true);

//   //   try {
//   //     const response = await axios.post(
//   //       `${API_BASE_URL}/Auth/login_user`,
//   //       loginParams
//   //     );

//   //     if (response.data.statusCode === 200) {
//   //       dispatch(logIn(response.data.userDetails));
//   //       console.log("User Login Response", response.data);

//   //       if (response.data.userDetails?.userRole === "SuperAdmin") {
//   //         navigate("/DashboardAIG");
//   //       } else {
//   //         navigate("/Dashboard");
//   //       }
//   //     } else {
//   //       toast.error(response.data.status);
//   //     }
//   //   } catch (error) {
//   //     toast.error("An error occurred. Please try again.");
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };

//   // changes by khalid to bypass fingerprint ends

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setLoginParams({ ...loginParams, [name]: value });
//   };

//   const dispatch = useDispatch();
//   const { isLoggedIn, userDetails } = useSelector((state) => state.auth);
//   console.log(userDetails);

//   const captureFingerprint = () => {
//     setFingerprintScannerLoading(true);
//     callSGIFPGetData((result) => {
//       successFunc1(result);
//       setFingerprintData(result.ISOTemplateBase64);
//       // setImageSrc2("data:image/bmp;base64," + result.BMPBase64);
//     }, errorFunc);
//   };

//   const matchFingerprints = () => {
//     setFingerprintScannerLoading(true);
//     matchFingerPrint(
//       databaseFingerprint,
//       fingerprintData,
//       (result) => {
//         const matchResult = succMatch(result);

//         // setMatchResult(matchResult);
//         // console.log(matchResult);

//         if (matchResult.matched) {
//           toast.success("fingerpirnt matched successfully");
//           if (userLoginDetails) {
//             dispatch(logIn(userLoginDetails));
//             navigate("/Dashboard");
//           }
//         } else {
//           toast.error("fingerpirnt does not matched please try again");
//         }
//         return matchResult;
//       },
//       (error) => {
//         const matchResult = failureFunc(error);
//         toast.error("please scan your fingerpirnt again");
//         // setMatchResult(matchResult);
//         return matchResult;
//       }
//     ).catch((error) => {
//       console.error("Match error:", error);
//       toast.error("please scan your fingerpirnt again");
//     });
//     setFingerprintScannerLoading(false);
//   };

//   useEffect(() => {
//     if (databaseFingerprint) {
//       captureFingerprint();
//     }
//   }, [intializeFingerprintCapture]);

//   useEffect(() => {
//     if (fingerprintData) {
//       matchFingerprints();
//     }
//   }, [fingerprintData]);

//   return (
//     <>
//       {loading && <ApiLoader />}
//       {fingerprintScannerLoading && <FingerprintScannerLoader />}

//       {/* Main Content */}
//       <div className="flex flex-col bg-[#ffffff] overflow-hidden min-h-screen relative">
//         {/* Header positioned at the top-left */}
//         <div className="absolute top-0 left-0 p-4">
//           <Header />
//         </div>

//         {/* Content Area */}
//         <div className="flex-1 flex flex-col md:flex-row">
//           {/* Left Section */}
//           <div className="flex-1 flex flex-col items-center justify-center p-4 md:p-6">
//             <div className="w-full max-w-md bg-white items-center justify-center rounded-lg dark:bg-gray-800 p-6 space-y-4 md:space-y-6 sm:p-8 mt-12 md:mt-24">
//               <div className="centered-container text-center">
//                 <h1 className="text-2xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
//                   <strong>Welcome To CRS Login</strong>
//                 </h1>
//                 <h1 className="text-lg mt-2">Enter Your Login ID & Password</h1>
//               </div>
//               <form className="space-y-4 md:space-y-6" action="#">
//                 <div>
//                   <label
//                     htmlFor="email"
//                     className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
//                   >
//                     Email
//                   </label>
//                   <input
//                     type="email"
//                     name="email"
//                     id="email"
//                     value={loginParams.email}
//                     onChange={(e) => handleInputChange(e)}
//                     className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
//                     placeholder="name@company.com"
//                     required
//                   />
//                 </div>
//                 <div>
//                   <label
//                     htmlFor="password"
//                     className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
//                   >
//                     Password
//                   </label>
//                   <input
//                     type="password"
//                     name="password"
//                     id="password"
//                     value={loginParams.password}
//                     onChange={(e) => handleInputChange(e)}
//                     className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
//                     placeholder="••••••••"
//                     required
//                   />
//                 </div>
//                 <div className="mt-4">
//                   <button
//                     type="submit"
//                     onClick={(e) => handleSubmit(e)}
//                     className="w-full py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-black hover:bg-slate-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
//                   >
//                     Sign in
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>

//           {/* Right Section */}
//           <div className="flex-1 hidden md:flex justify-center items-center curved-background">
//             <img
//               src={logincrsimg}
//               alt="Images"
//               className="max-w-full h-auto object-cover"
//             />
//           </div>
//         </div>
//         {/* Footer */}
//         <Footer />
//       </div>
//     </>
//   );
// };

// export default Login;
